import { initReactI18next as e } from "react-i18next";
import t from "i18next";
import n from "i18next-browser-languagedetector";
var r = {
	app: {
		hideMainContent: "Hide main content",
		showMainContent: "Show main content"
	},
	chatPanel: {
		thinking: "The assistant is thinking…",
		sandbox: {
			starting: {
				pending: "Starting a sandbox",
				done: "Sandbox started",
				failed: "The sandbox failed to start"
			},
			resuming: {
				pending: "Resuming the sandbox",
				done: "Sandbox resumed",
				failed: "The sandbox failed to resume"
			}
		},
		input: {
			placeholder: "Ask about datasets, maps, or tables...",
			waitingForUploads: "Uploading file…",
			model: "Model: {{name}}",
			stopGeneration: "Stop",
			stoppingGeneration: "Stopping...",
			submit: "Submit",
			fileMenu: {
				open: "Add files to your message",
				upload: "Upload files",
				searchPlaceholder: "Search files…",
				noResults: "No files found"
			}
		},
		continue: {
			notice: "The assistant paused after reaching its step limit.",
			button: "Continue",
			settingsLink: "Adjust the limit in Settings",
			message: "Continue"
		},
		aiDisclaimer: "This assistant uses artificial intelligence and can make mistakes. Verify important information.",
		evaluation: {
			question: "Was this conversation helpful?",
			positive: "Yes, helpful",
			negative: "No, not helpful",
			commentLabel: "What went wrong? (optional)",
			commentPlaceholder: "Your comment",
			save: "Save",
			error: "Your feedback could not be saved. Please try again."
		},
		archived: {
			system: "This conversation was automatically archived by the platform. You can review its history but cannot send new messages.",
			admin: "This conversation was archived by an administrator. You can review its history but cannot send new messages."
		},
		home: {
			greeting: "Hello",
			subtitle: "What would you like to work on today?"
		},
		webSearch: { searching: "Searching the web..." },
		tool: {
			names: {
				exec: "Executing shell command",
				cancelRun: "Cancelling an execution",
				inspectRun: "Checking an execution",
				writeFile: "Writing a file",
				readFile: "Reading a file",
				editFile: "Editing a file",
				viewImage: "Viewing an image",
				listStoredFiles: "Listing user files",
				importUpload: "Importing user file",
				exportFile: "Exporting a file",
				publishArtifact: "Publishing an artifact",
				loadSkill: "Loading skill",
				readSkillFile: "Reading skill file"
			},
			loadSkillTitle: "Loading skill \"{{name}}\"",
			writeFileTitle: "Writing file \"{{name}}\"",
			readFileTitle: "Reading file \"{{name}}\"",
			editFileTitle: "Editing file \"{{name}}\"",
			viewImageTitle: "Viewing image \"{{name}}\"",
			cancelled: "Cancelled",
			stillRunning: "still running",
			generationHint: "generating a large file can take a while",
			group: {
				running_one: "1 operation running",
				running_other: "{{count}} operations running",
				summary_one: "{{count}} operation",
				summary_other: "{{count}} operations",
				moreCount_one: "+{{count}} more",
				moreCount_other: "+{{count}} more",
				failed_one: "{{count}} failed",
				failed_other: "{{count}} failed",
				cancelled_one: "{{count}} cancelled",
				cancelled_other: "{{count}} cancelled",
				expand: "Show details",
				collapse: "Collapse",
				denied_one: "{{count}} denied",
				denied_other: "{{count}} denied"
			},
			approval: {
				question: "Allow this action?",
				approve: "Allow",
				deny: "Deny",
				approved: "Action allowed",
				denied: "Action denied"
			}
		},
		error: {
			generic: "An unexpected error occurred.",
			providerUnavailable: "The model is temporarily unavailable. Wait a few moments, then try again.",
			sandboxUnavailable: "The workspace could not start. Wait a few moments, then try again.",
			retryButton: "Retry",
			retryMessage: "Please try again",
			details: "Details"
		},
		connection: {
			reconnecting: "Connection lost, reconnecting…",
			lost: "Connection interrupted. Check your internet access, then retry."
		}
	},
	sidebar: {
		newChat: "New chat",
		newConversation: "New conversation",
		clearSearch: "Clear search",
		noResults: "No conversations found",
		empty: "Your conversations will appear here",
		emptyHint: "Start a new chat to begin",
		deleteConversation: "Delete conversation",
		conversationOptions: "Conversation options",
		renameConversation: "Rename",
		regenerateTitle: "Regenerate title",
		expand: "Expand sidebar",
		collapse: "Collapse sidebar",
		openMenu: "Open menu",
		menu: "Menu"
	},
	nav: {
		primary: "Primary navigation",
		home: "Home",
		conversations: "Conversations",
		skills: "Skills"
	},
	brand: { fallback: "Living Data" },
	home: {
		greeting: "Hello, {{name}}",
		greetingFallback: "Hello",
		heading: "What will you explore today?",
		composer: { label: "Start a new conversation" },
		suggestions: { label: "Suggestions" },
		resume: {
			title: "Resume your conversation",
			viewAll: "Conversations"
		}
	},
	conversations: {
		title: "Conversations",
		total_one: "{{count}} total",
		total_other: "{{count}} total",
		searchPlaceholder: "Search…",
		new: "New"
	},
	conversationItem: {
		files_one: "{{count}} file",
		files_other: "{{count}} files",
		artefacts_one: "{{count}} artifact",
		artefacts_other: "{{count}} artifacts"
	},
	account: {
		myAccount: "My account",
		settings: "Settings",
		logout: "Sign out",
		back: "Back",
		sections: {
			preferences: "Preferences",
			organizations: "My organizations"
		},
		preferencesDescription: "The language the interface is shown in.",
		organizations: {
			description: "The organizations you are a member of.",
			invitationsTitle: "Invitations received",
			listTitle: "Organizations ({{count}})",
			listTitleEmpty: "Organizations",
			roles: {
				admin: "Admin",
				member: "Member"
			},
			emptyTitle: "You are not a member of any organization",
			empty: "Only your organization's admin can invite you.",
			emptyCanCreate: "Create one to work as a team.",
			loadFailed: "Your organizations could not be loaded.",
			retry: "Retry",
			createTitle: "Create an organization",
			namePlaceholder: "Organization name",
			create: "Create",
			createHint: "You will be its admin.",
			createFailed: "The organization could not be created.",
			leave: "Leave",
			leaveFailed: "The organization could not be left.",
			leaveDialog: {
				title: "Leave {{name}}?",
				description: "You will no longer be a member. To come back, an admin will have to add you again."
			},
			settings: "Settings",
			actions: "Actions for {{name}}",
			cancel: "Cancel"
		}
	},
	chat: {
		backToList: "Back to conversations",
		credits: {
			exhaustedTitle: "You're out of credits.",
			viewUsage: "View my usage"
		}
	},
	deleteDialog: {
		title: "Delete conversation?",
		description: "This will permanently delete \"{{title}}\" and all its messages, artifacts, and data files. This action cannot be undone.",
		cancel: "Cancel",
		delete: "Delete",
		deleting: "Deleting...",
		success: "Conversation deleted successfully",
		error: "Failed to delete conversation"
	},
	renameDialog: {
		title: "Rename conversation",
		description: "Update the title of this conversation.",
		label: "Conversation title",
		placeholder: "Enter a title",
		save: "Save",
		saving: "Saving...",
		cancel: "Cancel",
		success: "Conversation renamed",
		error: "Failed to rename conversation"
	},
	regenerateTitle: {
		success: "Title regenerated",
		error: "Failed to regenerate title"
	},
	time: {
		today: "Today",
		yesterday: "Yesterday",
		thisWeek: "This week",
		thisMonth: "This month"
	},
	artifact: {
		loading: "Loading artifact...",
		expand: "Expand artifact",
		collapse: "Collapse artifact",
		error: {
			loading: "Loading error",
			loadingDescription: "The content could not be loaded. Details below.",
			rendering: "Unable to display this artifact",
			renderingDescription: "Artifact rendering failed. Details below.",
			unsupportedType: "Unsupported artifact type: {{type}}",
			unsupportedTypeDescription: "This artifact cannot be displayed with its current type."
		},
		type: {
			table: "Table",
			map: "Map",
			chart: "Chart",
			webpage: "Webpage",
			html: "Webpage"
		},
		map: {
			searchPlaceholder: "Search for an address…",
			settings: {
				label: "Settings",
				search: "Search bar",
				scale: "Scale bar"
			}
		},
		table: {
			loadingData: "Loading CSV data...",
			errorLoading: "Error loading table",
			errorLoadingDescription: "The table could not be loaded. Details below.",
			noData: "No data available",
			searchPlaceholder: "Search in table...",
			noResults: "No matching results",
			pageInfo: "Page {{current}} of {{total}}",
			boolTrue: "Yes",
			boolFalse: "No",
			openExternal: "Open link in new tab",
			imageAlt: "Image",
			invalidValue: "Ignored value: {{value}}"
		},
		chart: {
			loadingData: "Loading chart data...",
			errorLoading: "Error loading chart",
			errorLoadingDescription: "The chart could not be loaded. Details below."
		},
		webpage: {
			iframeTitle: "Embedded webpage",
			errorLoading: "Invalid webpage",
			errorLoadingDescription: "The webpage configuration is missing a valid URL."
		},
		version: "Version {{version}}"
	},
	notFound: {
		title: "Page not found",
		description: "The page you're looking for doesn't exist or has been moved.",
		backToHome: "Back to home"
	},
	noPlan: {
		retry: "Try again",
		chooseTitle: "Choose a plan",
		chooseDescription: "Your account is not on a plan yet. Pick one to start.",
		creditsPerPeriod: "{{credits}} credits per month",
		choose: "Choose",
		paid: "Paid — not available from your account yet",
		chooseFailed: "This plan could not be applied."
	},
	errors: {
		artifactLoadFailed: "Failed to load artifact",
		conversationsLoadFailed: "Failed to load conversations",
		conversationLoadFailed: "Failed to load conversation",
		conversationCreateFailed: "Failed to create conversation",
		messageInProgress: "A message is already being processed for this conversation",
		sendMessageFailed: "Failed to send message. Please try again.",
		stopGenerationFailed: "Interruption failed.",
		invalidConversationOrArtifact: "Invalid conversation or artifact",
		inlineErrorDescription: "The content could not be displayed. Details below.",
		technicalDetails: "Show technical details"
	},
	share: {
		title: "Share artifact",
		descriptionShared: "This artifact is now publicly accessible via the link below.",
		descriptionCreating: "Creating a share link...",
		shareArtifact: "Share",
		manageShare: "Manage share",
		copied: "Link copied to clipboard",
		removed: "Share link removed",
		removeShare: "Stop sharing",
		close: "Close",
		cancel: "Cancel",
		errorCreating: "Failed to create share link",
		errorRemoving: "Failed to remove share link",
		errorCopying: "Failed to copy link",
		copyLink: "Copy link to clipboard",
		madeWith: "Made with",
		page: {
			defaultTitle: "Artifact",
			missingToken: "Missing share token",
			missingTokenDescription: "The share link is incomplete. Please check that you have the full URL.",
			invalidToken: "Invalid or expired share link",
			invalidTokenDescription: "This share link is no longer valid. It may have been revoked or never existed.",
			notFound: "Artifact not found",
			notFoundDescription: "The artifact you're looking for doesn't exist or has been deleted.",
			serverError: "Server error",
			serverErrorDescription: "An error occurred while loading the artifact. Please try again later.",
			unknownError: "Unable to load artifact",
			unknownErrorDescription: "An unexpected error occurred. Please try again."
		}
	},
	fileSystem: {
		addFiles: "Upload a file",
		attach: "Attach to message",
		detach: "Remove from message",
		dropZone: "Drop your files or folders here",
		emptyHint: "Imported files and folders become available to the assistant.",
		uploadFailed: "Couldn't add {{filename}}. Check your connection and try again.",
		uploadError: "error",
		noActiveConversation: "No active conversation",
		conversationCreateFailed: "Failed to create conversation for file upload",
		fileTooLarge: "File {{filename}} exceeds 100 MB",
		fileAlreadyExists: "File {{filename}} already exists. Delete it first to upload a new version.",
		deleteFailed: "Failed to delete file",
		dropFailed: "Failed to process dropped files"
	},
	fileCard: { download: "Download" },
	fileDetail: {
		notFound: "File not found",
		downloadComingSoon: "Download coming soon",
		size: "Size",
		lastUpdated: "Last updated",
		preview: {
			title: "Preview",
			body: "Preview coming soon",
			button: "Preview",
			tooltip: "Preview is not yet available"
		},
		producedByAssistant: "Produced by assistant",
		delete: "Delete file",
		deleteConfirmTitle: "Delete file",
		deleteConfirmDescription: "Are you sure you want to delete \"{{filename}}\"? This action cannot be undone.",
		deleteConfirmCancel: "Cancel",
		deleteConfirmSubmit: "Delete",
		deleting: "Deleting..."
	},
	panel: {
		closeDetail: "Close",
		sections: {
			files: "My files",
			filesCount: "{{count}} file",
			filesCount_other: "{{count}} files",
			showMoreFiles: "Show more",
			showLessFiles: "Show less",
			artifacts: "Publications",
			artifactsCount: "{{count}} publication",
			artifactsCount_other: "{{count}} publications",
			showMoreArtifacts: "Show more publications",
			showLessArtifacts: "Show less publications",
			producedFiles: "Produced files",
			producedFilesCount: "{{count}} file",
			producedFilesCount_other: "{{count}} files",
			showMoreProducedFiles: "Show more",
			showLessProducedFiles: "Show less"
		},
		sandbox: {
			title: "Sandbox",
			status: {
				none: "None",
				starting: "Starting",
				active: "Active",
				paused: "Paused"
			},
			hint: {
				none: "It will start with the next message.",
				starting: "It will be ready in a moment.",
				active: "It pauses by itself after a while without activity.",
				paused: "It will resume with the next message."
			},
			since: "Since {{time}}",
			pause: "Pause",
			pausing: "Pausing…",
			pauseBusy: "Available once the answer is done",
			pauseFailed: "The pause failed."
		}
	},
	streamdown: {
		copyCode: "Copy Code",
		downloadFile: "Download file",
		downloadDiagram: "Download diagram",
		downloadDiagramAsSvg: "Download diagram as SVG",
		downloadDiagramAsPng: "Download diagram as PNG",
		downloadDiagramAsMmd: "Download diagram as MMD",
		viewFullscreen: "View fullscreen",
		exitFullscreen: "Exit fullscreen",
		mermaidFormatSvg: "SVG",
		mermaidFormatPng: "PNG",
		mermaidFormatMmd: "MMD",
		copyTable: "Copy table",
		copyTableAsMarkdown: "Copy table as Markdown",
		copyTableAsCsv: "Copy table as CSV",
		copyTableAsTsv: "Copy table as TSV",
		downloadTable: "Download table",
		downloadTableAsCsv: "Download table as CSV",
		downloadTableAsMarkdown: "Download table as Markdown",
		tableFormatMarkdown: "Markdown",
		tableFormatCsv: "CSV",
		tableFormatTsv: "TSV",
		imageNotAvailable: "Image not available",
		downloadImage: "Download image",
		openExternalLink: "Open external link?",
		externalLinkWarning: "You're about to visit an external website.",
		close: "Close",
		copyLink: "Copy link",
		copied: "Copied",
		openLink: "Open link"
	},
	settings: {
		title: "Settings",
		sections: {
			agent: "Agent",
			models: "AI models",
			subscription: "Subscription"
		},
		agentDescription: "How the assistant works through its answers.",
		language: "Interface language",
		languageAuto: "Auto-detected",
		languageEn: "English",
		languageFr: "French",
		model: {
			description: "The model your next conversations start on. A conversation already started keeps its model.",
			empty: "No model is published on this deployment.",
			legend: "Model for new conversations",
			recommended: {
				title: "Recommended model",
				hint: "Currently {{name}}. Follows our recommendation automatically.",
				badge: "Recommended"
			},
			pickHint: "or pick your own model",
			columns: {
				model: "Model",
				cost: "Cost",
				intelligence: "Intelligence",
				context: "Context",
				vision: "Vision"
			},
			about: "About: {{column}}",
			help: {
				cost: "<b>Cost per message</b>How fast your credits go, compared with the recommended model (×1).",
				intelligence: "<b>Intelligence score</b>Overall score on reference benchmarks. The bar compares with the best model in the list.",
				context: "<b>Context size</b>How much text the model can take into account at once (messages, attached documents, tool results), in tokens. Beyond that, the oldest exchanges are no longer seen.",
				vision: "<b>Image analysis</b>The model can read attached images (screenshots, photos, diagrams). It does not generate any."
			},
			missing: {
				cost: "Not disclosed",
				intelligence: "Not rated",
				context: "Not disclosed"
			},
			restricted: {
				title: "Unavailable models",
				explanation: "Offered, but not to your account: your organisation's rules, for instance on where data is hosted, do not allow them."
			},
			retired: {
				title: "Withdrawn models",
				explanation: "No longer available for new conversations. Your existing conversations remain readable, and replies in them use the recommended model."
			},
			unknownWithFallback: "The model you chose ({{id}}) is no longer available. Your new conversations start on {{fallback}}.",
			retiredWithFallback: "{{name}} has been withdrawn. Your new conversations start on {{fallback}}.",
			restrictedPreference: "{{name}} is not available to your account: your new conversations cannot start. Pick another model."
		},
		summarization: "Summary-based compaction",
		summarizationBadge: "Preview",
		summarizationDescription: "In long conversations, older exchanges are replaced with a summary to keep the assistant fast and efficient. Experimental feature.",
		maxSteps: "Maximum steps per response",
		maxStepsDescription: "How many tool-use iterations the assistant can chain before stopping. A higher value enables more complex tasks but raises the cost and the risk of the assistant spiralling forward.",
		subscription: {
			description: "Your plan, and what you have used of it.",
			actionFailed: "This could not be done. Try again in a moment.",
			loadFailed: "Your plan could not be read.",
			retry: "Try again",
			plan: {
				title: "Plan",
				free: "Free",
				commitment: "{{count}}-month commitment",
				cancelledBadge: "Cancelled",
				renewsAt: "Renews on {{date}}",
				endsAt: "Ends on {{date}}",
				commitmentUntil: "Committed until {{date}}",
				scheduled: "Moves to {{plan}} on {{date}}",
				cancelScheduled: "Cancel this change",
				cancelled: "cancelled on {{date}}",
				withdraw: "Keep my plan",
				change: "Change plan",
				cancel: "Cancel subscription",
				managed: "Your plan cannot be changed from your account.",
				rate: "Usage rate {{rate}}: each use counts {{coefficient}} times its price, on your plan credits and your top-ups alike."
			},
			usage: {
				title: "Usage",
				period: "Current period: {{range}}",
				planCredits: "Plan credits",
				noCredits: "Your plan includes no credits.",
				recharges: "Top-ups",
				rechargesUsed: "Used this period",
				rechargesRemaining: "Remaining",
				blocked: "No credits left.",
				nextGrant: "New credits on {{date}}."
			},
			cancelDialog: {
				title: "Cancel your subscription?",
				description: "Your plan stays active until {{date}}, and will not renew. You can change your mind until then.",
				keep: "Keep my plan",
				confirm: "Cancel subscription",
				cancelling: "Cancelling…"
			},
			changeDialog: {
				title: "Change plan",
				description: "Moving up takes effect at once. Fewer credits, or leaving a paid plan, waits for the end of your commitment.",
				current: "Current plan",
				credits: "{{credits}} credits per month",
				now: "Takes effect now",
				termEnd: "Takes effect on {{date}}",
				unavailable: "Not yet available from your account",
				choose: "Choose",
				applying: "Applying…",
				confirmTitle: "Move to {{plan}}?",
				confirmNow: "You move to {{plan}} now. Your renewal date does not change, and you receive the difference in credits for the rest of the period.",
				confirmTermEnd: "You move to {{plan}} on {{date}}, at the end of your commitment. Until then, nothing changes. You can cancel this change until that date.",
				back: "Back",
				confirm: "Confirm",
				rate: "usage rate {{rate}}"
			}
		}
	},
	login: {
		title: "Sign In",
		subtitle: "Enter your email to receive a magic link",
		emailPlaceholder: "Enter your email",
		submit: "Send link",
		submitting: "Sending...",
		validation: {
			required: "Email is required",
			invalid: "Please enter a valid email address"
		},
		success: {
			title: "Check your inbox",
			description: "You will receive a link by email"
		},
		error: {
			rateLimited: "Too many requests. Please try again later.",
			serverError: "An error occurred. Please try again."
		}
	},
	skills: {
		title: "Skills",
		description: "Capabilities the assistant can use in your conversations: official, shared by your organization, or built by the community.",
		create: {
			failed: "Skill import failed.",
			label: "Create"
		},
		createError: { dismiss: "Dismiss" },
		search: {
			placeholder: "Search a skill…",
			clear: "Clear search"
		},
		tabs: {
			all: "All",
			mine: "My skills",
			system: "System"
		},
		bundle: {
			dropLabel: "Drop files or a folder here",
			addFiles: "Add files",
			restore: "Restore",
			status: {
				added: "Added",
				modified: "Modified",
				replaced: "Replaced",
				removed: "Removed"
			},
			pendingChanges_one: "{{count}} pending change",
			pendingChanges_other: "{{count}} pending changes",
			save: "Save changes",
			saving: "Saving…",
			cancel: "Cancel",
			create: "Create skill",
			creating: "Creating…",
			errors: {
				missingSkillMd: "A skill must include a SKILL.md file.",
				tooManyFiles: "A skill may contain at most {{max}} files.",
				fileTooLarge: "\"{{name}}\" exceeds the {{maxMb}} MB limit.",
				totalTooLarge: "The bundle exceeds the {{maxMb}} MB total limit.",
				invalidPath: "Invalid file path: \"{{path}}\".",
				duplicatePath: "Two files share the same path.",
				saveFailed: "Saving changes failed.",
				createFailed: "Creating the skill failed.",
				invalidSkill: "This skill cannot be saved. Check its identifier (lowercase letters, digits and hyphens) and the text telling the assistant when to use it."
			}
		},
		card: {
			install: "Install",
			installed: "Installed",
			ownerType: {
				user: "MINE",
				system: "SYSTEM"
			},
			status: {
				stable: "STABLE",
				beta: "BETA",
				experimental: "EXPERIMENTAL",
				preview: "PREVIEW",
				deprecated: "DEPRECATED"
			}
		},
		empty: {
			cta: "Create",
			clearLink: "Clear filters",
			noSkills: {
				title: "No skills yet",
				description: "Import your first skill to extend the assistant's capabilities."
			},
			noSkillsForTab: {
				title: "No skills in this tab",
				description: "Try another tab or create a skill."
			},
			noSearchResults: {
				title: "No results",
				description: "No skill matches your search."
			}
		},
		error: {
			title: "Unable to load skills.",
			retry: "Retry"
		},
		new: {
			title: "Create a skill",
			back: "Skills",
			intro: "A skill gives the assistant a specific capability, used when a request calls for it."
		},
		detail: {
			back: "All skills",
			updatedAt: "Updated {{date}}",
			notFound: {
				title: "Skill not found",
				description: "This skill does not exist or is not accessible.",
				back: "Back to skills"
			},
			error: {
				title: "Unable to load this skill.",
				retry: "Retry"
			},
			edit: {
				button: "Edit",
				dropFile: "Upload a file",
				delete: "Delete file",
				editorPlaceholder: "File content…",
				binaryHint: "Binary file: use “Upload a file” to replace it.",
				discard: {
					title: "Discard changes?",
					description: "You have unsaved changes. Leaving the editor will discard them.",
					confirm: "Discard",
					cancel: "Keep editing"
				}
			},
			files: {
				label: "Files",
				raw: "Raw",
				loading: "Loading…",
				loadError: "Unable to load this file.",
				badge: {
					readme: "Readme",
					skill: "LLM"
				}
			},
			noReadme: "This skill has no README.",
			dependencies: { title: "Dependencies" },
			danger: {
				title: "Danger zone",
				deleteTitle: "Delete the skill",
				description: "Deleting a skill is permanent.",
				delete: "Delete"
			},
			deleteDialog: {
				title: "Delete \"{{title}}\"?",
				description: "This action is irreversible. The skill and its bundle will be permanently deleted.",
				confirm: "Delete",
				cancel: "Cancel",
				deleting: "Deleting…",
				failed: "Deletion failed."
			},
			rename: {
				title: "Rename this skill?",
				description: "The skill's name changed. The name is its unique identifier, so confirm this is intended before saving.",
				confirm: "Rename and save",
				cancel: "Cancel",
				renaming: "Renaming…",
				failed: "Renaming failed."
			},
			publish: {
				button: "Publish",
				publishing: "Publishing…",
				failed: "Publishing failed.",
				badge: "Unpublished changes"
			}
		},
		form: {
			modeLabel: "Editing mode",
			modeForm: "Assisted",
			modeRaw: "Advanced",
			nonScalar: "This field holds a value the form cannot display. Edit it in {{mode}} mode.",
			identifierLine: "Identifier",
			identifierPending: "derived from the title",
			identifierEdit: "Change",
			localized: "This field exists in several languages, which the form cannot show. Edit it in {{mode}} mode.",
			required: "This field is needed for the skill to work.",
			unavailable: {
				invalidYaml: "The form cannot be shown: the text has an error on line {{line}}.",
				invalidYamlNoLine: "The form cannot be shown: the text has a syntax error.",
				notAMapping: "The form cannot be shown: the file header is not a list of fields."
			},
			fields: {
				title: { label: "Title" },
				name: {
					label: "Identifier",
					description: "Lowercase letters, digits and hyphens. Changing it renames the skill."
				},
				summary: {
					label: "Description",
					description: "With no description, the entry shows the “When to use this skill” text."
				},
				description: {
					label: "When to use this skill",
					description: "This is the only text the assistant reads to decide. Describe the requests in the words your users actually say, and list them in full: write “etc.” and the assistant makes up the rest."
				},
				body: {
					label: "Instructions",
					description: "The manual the assistant follows when it uses the skill. Get to the point: a concrete example beats a paragraph of explanation."
				}
			},
			warnings: {
				noIdentifier: "Enter an identifier, or a title that yields one: this title holds no letter or digit.",
				invalidIdentifier: "An identifier is written in lowercase letters, digits and hyphens (example: skill-name)."
			},
			sections: {
				catalog: {
					title: "The skill's catalogue entry",
					description: "What people read in the catalogue when choosing it."
				},
				agent: {
					title: "What drives the assistant",
					description: "The assistant reads both: the first to decide whether to use the skill, the second to carry it out."
				}
			},
			optional: "optional"
		}
	},
	markdownEditor: {
		tabs: {
			edit: "Edit",
			preview: "Preview",
			label: "Editor view"
		},
		emptyPreview: "Nothing to preview yet.",
		toolbar: {
			label: "Formatting",
			heading: "Heading",
			headingLevel: "Heading {{level}}",
			paragraph: "Normal text",
			bold: "Bold",
			italic: "Italic",
			strikethrough: "Strikethrough",
			bulletList: "Bulleted list",
			orderedList: "Numbered list",
			taskList: "Task list",
			quote: "Quote",
			inlineCode: "Code",
			codeBlock: "Code block",
			link: "Link",
			image: "Image",
			table: "Table",
			horizontalRule: "Horizontal rule",
			column: "Column"
		}
	},
	invitations: {
		title: "Invitations",
		fromInviter: "From {{inviter}}, valid until {{date}}.",
		validUntil: "Valid until {{date}}.",
		accept: "Join",
		decline: "Decline",
		joined: "You joined {{organization}}.",
		declined: "The invitation to join {{organization}} is declined.",
		acceptFailed: "The organization could not be joined.",
		declineFailed: "The invitation could not be declined."
	},
	organizationSettings: {
		title: "Organization settings",
		sections: {
			general: "General",
			members: "Members"
		},
		loadFailed: "Could not load the organization.",
		retry: "Try again",
		notFound: {
			title: "Organization not found",
			description: "It does not exist, or you are no longer a member.",
			back: "My organizations"
		},
		members: {
			description: "Who belongs to the organization, and with which role.",
			listTitle: "Members ({{count}})",
			adminCount_one: "{{count}} admin",
			adminCount_other: "{{count}} admins",
			you: "{{name}} (you)",
			sinceWithEmail: "{{email}} · since {{date}}",
			since: "Since {{date}}",
			inviteTitle: "Invite a member",
			emailLabel: "Email address",
			emailPlaceholder: "address@example.com",
			invite: "Invite",
			inviteHint: "They receive an email and find the invitation when signing in with this address. They join as a member. The invitation stays valid for 14 days.",
			invited: "Invitation sent to {{email}}.",
			inviteFailed: "The invitation could not be sent.",
			pending: "Sent on {{sent}} · expires on {{expires}}",
			noPending: "No pending invitations.",
			revoke: "Remove",
			revoked: "Invitation removed.",
			revokeFailed: "The invitation could not be removed.",
			unnamed: "Unnamed member",
			revokeLabel: "Remove the invitation for {{email}}",
			roleLabel: "Role of {{name}}",
			roleFailed: "The role could not be changed.",
			nowAdmin: "{{name}} is now an admin.",
			nowMember: "{{name}} is now a member.",
			lastAdmin: "Only admin: their role cannot change until another member is promoted.",
			remove: "Remove from the organization",
			removeFailed: "The member could not be removed.",
			removed: "{{name}} is no longer part of the organization.",
			removeDialog: {
				title: "Remove {{name}}?",
				description: "{{name}} loses access to the organization. To come back, they will have to be invited again."
			},
			actions: "Actions for {{name}}"
		},
		general: {
			description: "The organization's identity.",
			name: "Name",
			rename: "Rename",
			save: "Save",
			cancel: "Cancel",
			renamed: "Organization renamed.",
			renameFailed: "The organization could not be renamed.",
			createdAt: "Created on",
			yourRole: "Your role",
			dangerZone: "Danger zone",
			leaveTitle: "Leave the organization",
			leaveDescription: "You will no longer be a member. To come back, an admin will have to invite you again.",
			left: "You left {{name}}.",
			deleteTitle: "Delete the organization",
			deleteDescription: "All its members lose access to it. This deletion is permanent.",
			delete: "Delete",
			deleted: "{{name}} is deleted.",
			deleteFailed: "The organization could not be deleted.",
			deleteDialog: {
				title: "Delete {{name}}?",
				description_one: "Its only member loses access to it. This deletion is permanent.",
				description_other: "Its {{count}} members lose access to it. This deletion is permanent."
			}
		}
	}
}, i = {
	app: {
		hideMainContent: "Masquer la zone principale",
		showMainContent: "Afficher la zone principale"
	},
	chatPanel: {
		thinking: "L'assistant réfléchit…",
		sandbox: {
			starting: {
				pending: "Démarrage d'une sandbox",
				done: "Sandbox démarrée",
				failed: "Échec du démarrage de la sandbox"
			},
			resuming: {
				pending: "Reprise de la sandbox",
				done: "Sandbox reprise",
				failed: "Échec de la reprise de la sandbox"
			}
		},
		input: {
			placeholder: "Posez des questions sur les jeux de données, cartes ou tableaux...",
			waitingForUploads: "Fichier en cours d'envoi…",
			model: "Modèle : {{name}}",
			stopGeneration: "Arrêter",
			stoppingGeneration: "Interruption…",
			submit: "Envoyer",
			fileMenu: {
				open: "Ajouter des fichiers au message",
				upload: "Déposer des fichiers",
				searchPlaceholder: "Rechercher un fichier…",
				noResults: "Aucun fichier trouvé"
			}
		},
		continue: {
			notice: "L'assistant s'est arrêté après avoir atteint sa limite d'étapes.",
			button: "Continuer",
			settingsLink: "Régler la limite dans les Paramètres",
			message: "Continue"
		},
		aiDisclaimer: "Cet assistant utilise l'intelligence artificielle et peut faire des erreurs. Vérifiez les informations importantes.",
		evaluation: {
			question: "Cette conversation vous a-t-elle aidé ?",
			positive: "Oui, utile",
			negative: "Non, pas utile",
			commentLabel: "Qu'est-ce qui n'a pas marché ? (facultatif)",
			commentPlaceholder: "Votre commentaire",
			save: "Enregistrer",
			error: "Votre avis n'a pas pu être enregistré. Réessayez."
		},
		archived: {
			system: "Cette conversation a été archivée automatiquement par la plateforme. Vous pouvez consulter son historique mais ne pouvez plus envoyer de message.",
			admin: "Cette conversation a été archivée par un administrateur. Vous pouvez consulter son historique mais ne pouvez plus envoyer de message."
		},
		home: {
			greeting: "Bonjour",
			subtitle: "Sur quoi souhaitez-vous travailler aujourd'hui ?"
		},
		webSearch: { searching: "Recherche sur le Web..." },
		tool: {
			names: {
				exec: "Exécution d'une commande shell",
				cancelRun: "Annulation d'une exécution",
				inspectRun: "Vérification d'une exécution",
				writeFile: "Écriture d'un fichier",
				readFile: "Lecture d'un fichier",
				editFile: "Modification d'un fichier",
				viewImage: "Lecture d'une image",
				listStoredFiles: "Liste des fichiers utilisateur",
				importUpload: "Import d'un fichier utilisateur",
				exportFile: "Export d'un fichier",
				publishArtifact: "Publication d'un artefact",
				loadSkill: "Chargement d'une compétence",
				readSkillFile: "Lecture d'un fichier de compétence"
			},
			loadSkillTitle: "Chargement de la compétence « {{name}} »",
			writeFileTitle: "Écriture du fichier « {{name}} »",
			readFileTitle: "Lecture du fichier « {{name}} »",
			editFileTitle: "Modification du fichier « {{name}} »",
			viewImageTitle: "Lecture de l'image « {{name}} »",
			cancelled: "Annulé",
			stillRunning: "toujours en cours",
			generationHint: "la génération peut être longue pour un gros fichier",
			group: {
				running_one: "1 opération en cours",
				running_other: "{{count}} opérations en cours",
				summary_one: "{{count}} opération",
				summary_other: "{{count}} opérations",
				moreCount_one: "+{{count}} autre",
				moreCount_other: "+{{count}} autres",
				failed_one: "{{count}} en erreur",
				failed_other: "{{count}} en erreur",
				cancelled_one: "{{count}} annulée",
				cancelled_other: "{{count}} annulées",
				expand: "Afficher le détail",
				collapse: "Réduire",
				denied_one: "{{count}} refusée",
				denied_other: "{{count}} refusées"
			},
			approval: {
				question: "Autoriser cette action ?",
				approve: "Autoriser",
				deny: "Refuser",
				approved: "Action autorisée",
				denied: "Action refusée"
			}
		},
		error: {
			generic: "Une erreur inattendue est survenue.",
			providerUnavailable: "Le modèle est momentanément indisponible. Patientez quelques instants, puis relancez.",
			sandboxUnavailable: "L'environnement de travail n'a pas pu démarrer. Patientez quelques instants, puis relancez.",
			retryButton: "Relancer",
			retryMessage: "Réessaie",
			details: "Détails"
		},
		connection: {
			reconnecting: "Connexion perdue, reconnexion en cours…",
			lost: "Connexion interrompue. Vérifiez votre accès à internet, puis relancez."
		}
	},
	sidebar: {
		newChat: "Nouvelle discussion",
		newConversation: "Nouvelle conversation",
		clearSearch: "Effacer la recherche",
		noResults: "Aucune conversation trouvée",
		empty: "Vos conversations apparaîtront ici",
		emptyHint: "Démarrez une nouvelle discussion pour commencer",
		deleteConversation: "Supprimer la conversation",
		conversationOptions: "Options de la conversation",
		renameConversation: "Renommer",
		regenerateTitle: "Régénérer le titre",
		expand: "Développer la barre latérale",
		collapse: "Réduire la barre latérale",
		openMenu: "Ouvrir le menu",
		menu: "Menu"
	},
	nav: {
		primary: "Navigation principale",
		home: "Accueil",
		conversations: "Conversations",
		skills: "Compétences"
	},
	brand: { fallback: "Living Data" },
	home: {
		greeting: "Bonjour, {{name}}",
		greetingFallback: "Bonjour",
		heading: "Qu'allez-vous explorer aujourd'hui ?",
		composer: { label: "Démarrer une nouvelle conversation" },
		suggestions: { label: "Suggestions" },
		resume: {
			title: "Reprendre votre conversation",
			viewAll: "Conversations"
		}
	},
	conversations: {
		title: "Conversations",
		total_one: "{{count}} au total",
		total_other: "{{count}} au total",
		searchPlaceholder: "Rechercher…",
		new: "Nouvelle"
	},
	conversationItem: {
		files_one: "{{count}} fichier",
		files_other: "{{count}} fichiers",
		artefacts_one: "{{count}} artefact",
		artefacts_other: "{{count}} artefacts"
	},
	account: {
		myAccount: "Mon compte",
		settings: "Paramètres",
		logout: "Se déconnecter",
		back: "Retour",
		sections: {
			preferences: "Préférences",
			organizations: "Mes organisations"
		},
		preferencesDescription: "La langue dans laquelle l'interface s'affiche.",
		organizations: {
			description: "Les organisations dont vous êtes membre.",
			invitationsTitle: "Invitations reçues",
			listTitle: "Organisations ({{count}})",
			listTitleEmpty: "Organisations",
			roles: {
				admin: "Administrateur",
				member: "Membre"
			},
			emptyTitle: "Vous n'êtes membre d'aucune organisation",
			empty: "Seul l'administrateur de votre structure peut vous y inviter.",
			emptyCanCreate: "Créez-en une pour travailler en équipe.",
			loadFailed: "Impossible de charger vos organisations.",
			retry: "Réessayer",
			createTitle: "Créer une organisation",
			namePlaceholder: "Nom de l'organisation",
			create: "Créer",
			createHint: "Vous en serez l'administrateur.",
			createFailed: "L'organisation n'a pas pu être créée.",
			leave: "Quitter",
			leaveFailed: "Impossible de quitter l'organisation.",
			leaveDialog: {
				title: "Quitter {{name}} ?",
				description: "Vous n'en serez plus membre. Pour y revenir, un administrateur devra vous y ajouter de nouveau."
			},
			settings: "Paramètres",
			actions: "Actions pour {{name}}",
			cancel: "Annuler"
		}
	},
	chat: {
		backToList: "Retour aux conversations",
		credits: {
			exhaustedTitle: "Plus de crédits disponibles.",
			viewUsage: "Voir ma consommation"
		}
	},
	deleteDialog: {
		title: "Supprimer la conversation ?",
		description: "Cette action supprimera définitivement \"{{title}}\" ainsi que tous ses messages, artefacts et fichiers de données. Cette action est irréversible.",
		cancel: "Annuler",
		delete: "Supprimer",
		deleting: "Suppression...",
		success: "Conversation supprimée avec succès",
		error: "Échec de la suppression de la conversation"
	},
	renameDialog: {
		title: "Renommer la conversation",
		description: "Modifiez le titre de cette conversation.",
		label: "Titre de la conversation",
		placeholder: "Saisissez un titre",
		save: "Enregistrer",
		saving: "Enregistrement...",
		cancel: "Annuler",
		success: "Conversation renommée",
		error: "Échec du renommage de la conversation"
	},
	regenerateTitle: {
		success: "Titre régénéré",
		error: "Échec de la régénération du titre"
	},
	time: {
		today: "Aujourd'hui",
		yesterday: "Hier",
		thisWeek: "Cette semaine",
		thisMonth: "Ce mois-ci"
	},
	artifact: {
		loading: "Chargement de l'artefact...",
		expand: "Agrandir l'artefact",
		collapse: "Réduire l'artefact",
		error: {
			loading: "Erreur de chargement",
			loadingDescription: "Le contenu n'a pas pu être chargé. Détails ci-dessous.",
			rendering: "Impossible d'afficher cet artefact",
			renderingDescription: "Le rendu de l'artefact a échoué. Détails ci-dessous.",
			unsupportedType: "Type d'artefact non supporté: {{type}}",
			unsupportedTypeDescription: "Cet artefact ne peut pas être affiché avec le type actuel."
		},
		type: {
			table: "Tableau",
			map: "Carte",
			chart: "Graphique",
			webpage: "Page web",
			html: "Page web"
		},
		map: {
			searchPlaceholder: "Rechercher une adresse…",
			settings: {
				label: "Paramètres",
				search: "Barre de recherche",
				scale: "Barre d'échelle"
			}
		},
		table: {
			loadingData: "Chargement des données CSV...",
			errorLoading: "Erreur de chargement du tableau",
			errorLoadingDescription: "Le tableau n'a pas pu être chargé. Détails ci-dessous.",
			noData: "Aucune donnée disponible",
			searchPlaceholder: "Rechercher dans le tableau...",
			noResults: "Aucun résultat correspondant",
			pageInfo: "Page {{current}} sur {{total}}",
			boolTrue: "Oui",
			boolFalse: "Non",
			openExternal: "Ouvrir le lien dans un nouvel onglet",
			imageAlt: "Image",
			invalidValue: "Valeur ignorée : {{value}}"
		},
		chart: {
			loadingData: "Chargement des données du graphique...",
			errorLoading: "Erreur de chargement du graphique",
			errorLoadingDescription: "Le graphique n'a pas pu être chargé. Détails ci-dessous."
		},
		webpage: {
			iframeTitle: "Page web intégrée",
			errorLoading: "Page web invalide",
			errorLoadingDescription: "La configuration de la page web ne contient pas d'URL valide."
		},
		version: "Version {{version}}"
	},
	notFound: {
		title: "Page introuvable",
		description: "La page que vous recherchez n'existe pas ou a été déplacée.",
		backToHome: "Retour à l'accueil"
	},
	noPlan: {
		retry: "Réessayer",
		chooseTitle: "Choisissez une formule",
		chooseDescription: "Votre compte n'a pas encore de formule. Choisissez-en une pour commencer.",
		creditsPerPeriod: "{{credits}} crédits par mois",
		choose: "Choisir",
		paid: "Payante — pas encore disponible depuis votre compte",
		chooseFailed: "Cette formule n'a pas pu être appliquée."
	},
	errors: {
		artifactLoadFailed: "Échec du chargement de l'artefact",
		conversationsLoadFailed: "Échec du chargement des conversations",
		conversationLoadFailed: "Échec du chargement de la conversation",
		conversationCreateFailed: "Échec de la création de la conversation",
		messageInProgress: "Un message est déjà en cours de traitement pour cette conversation",
		sendMessageFailed: "Échec de l'envoi du message. Veuillez réessayer.",
		stopGenerationFailed: "L’interruption a échoué.",
		invalidConversationOrArtifact: "Conversation ou artefact invalide",
		inlineErrorDescription: "Le contenu n'a pas pu être affiché. Détails ci-dessous.",
		technicalDetails: "Afficher les détails techniques"
	},
	share: {
		title: "Partager l'artefact",
		descriptionShared: "Cet artefact est désormais accessible publiquement via le lien ci-dessous.",
		descriptionCreating: "Création du lien de partage...",
		shareArtifact: "Partager",
		manageShare: "Gérer le partage",
		copied: "Lien copié dans le presse-papier",
		removed: "Lien de partage supprimé",
		removeShare: "Arrêter le partage",
		close: "Fermer",
		cancel: "Annuler",
		errorCreating: "Échec de la création du lien de partage",
		errorRemoving: "Échec de la suppression du lien de partage",
		errorCopying: "Échec de la copie du lien",
		copyLink: "Copier le lien dans le presse-papier",
		madeWith: "Fait avec",
		page: {
			defaultTitle: "Artefact",
			missingToken: "Lien de partage incomplet",
			missingTokenDescription: "Le lien de partage est incomplet. Vérifiez que vous avez l'URL complète.",
			invalidToken: "Lien de partage invalide ou expiré",
			invalidTokenDescription: "Ce lien de partage n'est plus valide. Il a peut-être été révoqué ou n'a jamais existé.",
			notFound: "Artefact introuvable",
			notFoundDescription: "L'artefact que vous recherchez n'existe pas ou a été supprimé.",
			serverError: "Erreur serveur",
			serverErrorDescription: "Une erreur est survenue lors du chargement de l'artefact. Veuillez réessayer plus tard.",
			unknownError: "Impossible de charger l'artefact",
			unknownErrorDescription: "Une erreur inattendue s'est produite. Veuillez réessayer."
		}
	},
	fileSystem: {
		addFiles: "Déposer un fichier",
		attach: "Joindre au message",
		detach: "Retirer du message",
		dropZone: "Déposez vos fichiers ou dossiers ici",
		emptyHint: "Les fichiers et dossiers importés seront disponibles pour l'assistant.",
		uploadFailed: "Impossible d'ajouter le fichier {{filename}}. Vérifiez votre connexion et réessayez.",
		uploadError: "erreur",
		noActiveConversation: "Aucune conversation active",
		conversationCreateFailed: "Impossible de créer une conversation pour l'upload",
		fileTooLarge: "Le fichier {{filename}} dépasse 100 Mo",
		fileAlreadyExists: "Le fichier {{filename}} existe déjà. Supprimez-le d'abord pour uploader une nouvelle version.",
		deleteFailed: "Échec de la suppression du fichier",
		dropFailed: "Impossible de traiter les fichiers déposés"
	},
	fileCard: { download: "Télécharger" },
	fileDetail: {
		notFound: "Fichier introuvable",
		downloadComingSoon: "Téléchargement bientôt disponible",
		size: "Taille",
		lastUpdated: "Dernière mise à jour",
		preview: {
			title: "Aperçu",
			body: "Aperçu bientôt disponible",
			button: "Aperçu",
			tooltip: "L'aperçu n'est pas encore disponible"
		},
		producedByAssistant: "Produit par l'assistant",
		delete: "Supprimer le fichier",
		deleteConfirmTitle: "Supprimer le fichier",
		deleteConfirmDescription: "Êtes-vous sûr de vouloir supprimer « {{filename}} » ? Cette action est irréversible.",
		deleteConfirmCancel: "Annuler",
		deleteConfirmSubmit: "Supprimer",
		deleting: "Suppression..."
	},
	panel: {
		closeDetail: "Fermer",
		sections: {
			files: "Mes fichiers",
			filesCount: "{{count}} fichier",
			filesCount_other: "{{count}} fichiers",
			showMoreFiles: "Afficher plus",
			showLessFiles: "Afficher moins",
			artifacts: "Publications",
			artifactsCount: "{{count}} publication",
			artifactsCount_other: "{{count}} publications",
			showMoreArtifacts: "Afficher plus de publications",
			showLessArtifacts: "Afficher moins de publications",
			producedFiles: "Fichiers produits",
			producedFilesCount: "{{count}} fichier",
			producedFilesCount_other: "{{count}} fichiers",
			showMoreProducedFiles: "Afficher plus",
			showLessProducedFiles: "Afficher moins"
		},
		sandbox: {
			title: "Sandbox",
			status: {
				none: "Aucune",
				starting: "En démarrage",
				active: "Active",
				paused: "En pause"
			},
			hint: {
				none: "Elle démarrera au prochain message.",
				starting: "Elle sera prête dans quelques instants.",
				active: "Elle se met en pause d'elle-même après un moment d'inactivité.",
				paused: "Elle reprendra au prochain message."
			},
			since: "Depuis {{time}}",
			pause: "Mettre en pause",
			pausing: "Mise en pause…",
			pauseBusy: "Possible une fois la réponse terminée",
			pauseFailed: "La mise en pause a échoué."
		}
	},
	streamdown: {
		copyCode: "Copier le code",
		downloadFile: "Télécharger le fichier",
		downloadDiagram: "Télécharger le diagramme",
		downloadDiagramAsSvg: "Télécharger le diagramme en SVG",
		downloadDiagramAsPng: "Télécharger le diagramme en PNG",
		downloadDiagramAsMmd: "Télécharger le diagramme en MMD",
		viewFullscreen: "Afficher en plein écran",
		exitFullscreen: "Quitter le plein écran",
		mermaidFormatSvg: "SVG",
		mermaidFormatPng: "PNG",
		mermaidFormatMmd: "MMD",
		copyTable: "Copier le tableau",
		copyTableAsMarkdown: "Copier le tableau en Markdown",
		copyTableAsCsv: "Copier le tableau en CSV",
		copyTableAsTsv: "Copier le tableau en TSV",
		downloadTable: "Télécharger le tableau",
		downloadTableAsCsv: "Télécharger le tableau en CSV",
		downloadTableAsMarkdown: "Télécharger le tableau en Markdown",
		tableFormatMarkdown: "Markdown",
		tableFormatCsv: "CSV",
		tableFormatTsv: "TSV",
		imageNotAvailable: "Image non disponible",
		downloadImage: "Télécharger l'image",
		openExternalLink: "Ouvrir le lien externe ?",
		externalLinkWarning: "Vous êtes sur le point de visiter un site externe.",
		close: "Fermer",
		copyLink: "Copier le lien",
		copied: "Copié",
		openLink: "Ouvrir le lien"
	},
	settings: {
		title: "Paramètres",
		sections: {
			agent: "Agent",
			models: "Modèles IA",
			subscription: "Abonnement"
		},
		agentDescription: "Comment l'assistant mène ses réponses.",
		language: "Langue de l'interface",
		languageAuto: "Auto-détecté",
		languageEn: "Anglais",
		languageFr: "Français",
		model: {
			description: "Le modèle utilisé au démarrage de vos prochaines conversations. Une conversation déjà commencée garde son modèle.",
			empty: "Aucun modèle n'est publié sur ce déploiement.",
			legend: "Modèle des nouvelles conversations",
			recommended: {
				title: "Modèle recommandé",
				hint: "Actuellement {{name}}. Suit automatiquement nos recommandations.",
				badge: "Recommandé"
			},
			pickHint: "ou sélectionnez le modèle de votre choix",
			columns: {
				model: "Modèle",
				cost: "Coût",
				intelligence: "Intelligence",
				context: "Contexte",
				vision: "Vision"
			},
			about: "À propos : {{column}}",
			help: {
				cost: "<b>Consommation par message</b>Vitesse à laquelle vos crédits sont consommés, comparée au modèle recommandé (×1).",
				intelligence: "<b>Score d'intelligence</b>Score global obtenu sur des tests de référence. La barre compare au meilleur modèle de la liste.",
				context: "<b>Taille du contexte</b>Quantité de texte que le modèle peut prendre en compte à la fois (messages, documents joints, résultats d'outils), en tokens. Au-delà, les échanges les plus anciens ne sont plus vus.",
				vision: "<b>Analyse d'images</b>Le modèle peut lire les images jointes (captures d'écran, photos, schémas). Il n'en génère pas."
			},
			missing: {
				cost: "Non communiqué",
				intelligence: "Non évalué",
				context: "Non communiqué"
			},
			restricted: {
				title: "Modèles indisponibles",
				explanation: "Proposés, mais pas avec votre compte : les règles de votre organisation, par exemple sur l'hébergement des données, ne permettent pas de les utiliser."
			},
			retired: {
				title: "Modèles retirés",
				explanation: "Plus disponibles pour les nouvelles conversations. Vos conversations existantes restent consultables, et vos réponses y utilisent le modèle recommandé."
			},
			unknownWithFallback: "Le modèle choisi ({{id}}) n'est plus disponible. Vos nouvelles conversations démarrent sur {{fallback}}.",
			retiredWithFallback: "{{name}} a été retiré. Vos nouvelles conversations démarrent sur {{fallback}}.",
			restrictedPreference: "{{name}} n'est pas disponible avec votre compte : vos nouvelles conversations ne pourront pas démarrer. Choisissez un autre modèle."
		},
		summarization: "Compaction par résumé",
		summarizationBadge: "Preview",
		summarizationDescription: "Dans les longues conversations, les anciens échanges sont remplacés par un résumé pour garder l'assistant rapide et économe. Fonctionnalité expérimentale.",
		maxSteps: "Nombre maximal d'étapes par réponse",
		maxStepsDescription: "Nombre d'itérations d'outils que l'assistant peut enchaîner avant de s'arrêter. Une valeur élevée autorise des tâches plus complexes, mais augmente le coût et le risque de fuite en avant de l'assistant.",
		subscription: {
			description: "Votre formule, et ce que vous en avez consommé.",
			actionFailed: "Cela n'a pas pu être fait. Réessayez dans un instant.",
			loadFailed: "Votre formule n'a pas pu être lue.",
			retry: "Réessayer",
			plan: {
				title: "Formule",
				free: "Gratuite",
				commitment: "Engagement {{count}} mois",
				cancelledBadge: "Résiliée",
				renewsAt: "Renouvelée le {{date}}",
				endsAt: "Prend fin le {{date}}",
				commitmentUntil: "Engagement jusqu'au {{date}}",
				scheduled: "Passe à {{plan}} le {{date}}",
				cancelScheduled: "Annuler ce changement",
				cancelled: "résiliée le {{date}}",
				withdraw: "Garder ma formule",
				change: "Changer d'offre",
				cancel: "Résilier l'abonnement",
				managed: "Votre formule ne se modifie pas depuis votre compte.",
				rate: "Vitesse de consommation {{rate}} : chaque usage compte {{coefficient}} fois son tarif, sur les crédits de la formule comme sur les recharges."
			},
			usage: {
				title: "Consommation",
				period: "Période en cours : {{range}}",
				planCredits: "Crédits de la formule",
				noCredits: "Votre formule ne comprend pas de crédits.",
				recharges: "Recharges",
				rechargesUsed: "Utilisés sur la période",
				rechargesRemaining: "Restants",
				blocked: "Plus de crédits disponibles.",
				nextGrant: "Nouveaux crédits le {{date}}."
			},
			cancelDialog: {
				title: "Résilier votre abonnement ?",
				description: "Votre formule reste active jusqu'au {{date}}, et ne sera pas renouvelée. Vous pouvez changer d'avis d'ici là.",
				keep: "Garder ma formule",
				confirm: "Résilier",
				cancelling: "Résiliation…"
			},
			changeDialog: {
				title: "Changer d'offre",
				description: "Monter prend effet tout de suite. Moins de crédits, ou quitter une formule payante, attend la fin de votre engagement.",
				current: "Formule actuelle",
				credits: "{{credits}} crédits par mois",
				now: "Prend effet tout de suite",
				termEnd: "Prend effet le {{date}}",
				unavailable: "Pas encore disponible depuis votre compte",
				choose: "Choisir",
				applying: "En cours…",
				confirmTitle: "Passer à {{plan}} ?",
				confirmNow: "Vous passez à {{plan}} tout de suite. Votre date de renouvellement ne change pas, et vous recevez l'écart de crédits pour le reste de la période.",
				confirmTermEnd: "Vous passez à {{plan}} le {{date}}, à la fin de votre engagement. D'ici là, rien ne change. Vous pouvez annuler ce changement jusqu'à cette date.",
				back: "Retour",
				confirm: "Confirmer",
				rate: "vitesse {{rate}}"
			}
		}
	},
	login: {
		title: "Connexion",
		subtitle: "Entrez votre email pour recevoir un lien magique",
		emailPlaceholder: "Entrez votre email",
		submit: "Envoyer le lien",
		submitting: "Envoi en cours...",
		validation: {
			required: "L'email est requis",
			invalid: "Veuillez entrer une adresse email valide"
		},
		success: {
			title: "Vérifiez votre boîte mail",
			description: "Vous allez recevoir un lien par email"
		},
		error: {
			rateLimited: "Trop de requêtes. Veuillez réessayer plus tard.",
			serverError: "Une erreur est survenue. Veuillez réessayer."
		}
	},
	skills: {
		title: "Compétences",
		description: "Des compétences que l'assistant peut mobiliser dans vos conversations : officielles, partagées par votre organisation ou créées par la communauté.",
		create: {
			failed: "L'import de la compétence a échoué.",
			label: "Créer"
		},
		createError: { dismiss: "Fermer" },
		search: {
			placeholder: "Rechercher une compétence…",
			clear: "Effacer la recherche"
		},
		tabs: {
			all: "Toutes",
			mine: "Mes compétences",
			system: "Système"
		},
		bundle: {
			dropLabel: "Déposez des fichiers ou un dossier ici",
			addFiles: "Ajouter des fichiers",
			restore: "Restaurer",
			status: {
				added: "Ajouté",
				modified: "Modifié",
				replaced: "Remplacé",
				removed: "Supprimé"
			},
			pendingChanges_one: "{{count}} modification en attente",
			pendingChanges_other: "{{count}} modifications en attente",
			save: "Enregistrer les modifications",
			saving: "Enregistrement…",
			cancel: "Annuler",
			create: "Créer la compétence",
			creating: "Création…",
			errors: {
				missingSkillMd: "Une compétence doit contenir un fichier SKILL.md.",
				tooManyFiles: "Une compétence peut contenir au maximum {{max}} fichiers.",
				fileTooLarge: "« {{name}} » dépasse la limite de {{maxMb}} Mo.",
				totalTooLarge: "Le bundle dépasse la limite totale de {{maxMb}} Mo.",
				invalidPath: "Chemin de fichier invalide : « {{path}} ».",
				duplicatePath: "Deux fichiers ont le même chemin.",
				saveFailed: "L'enregistrement des modifications a échoué.",
				createFailed: "La création de la compétence a échoué.",
				invalidSkill: "Cette compétence ne peut pas être enregistrée. Vérifiez son identifiant (minuscules, chiffres et tirets) et le texte qui dit à l'assistant quand l'utiliser."
			}
		},
		card: {
			install: "Installer",
			installed: "Installé",
			ownerType: {
				user: "Moi",
				system: "SYSTÈME"
			},
			status: {
				stable: "STABLE",
				beta: "BÊTA",
				experimental: "EXPÉRIMENTAL",
				preview: "PRÉVERSION",
				deprecated: "OBSOLÈTE"
			}
		},
		empty: {
			cta: "Créer",
			clearLink: "Effacer les filtres",
			noSkills: {
				title: "Aucune compétence pour l'instant",
				description: "Importez votre première compétence pour étendre les capacités de l'assistant."
			},
			noSkillsForTab: {
				title: "Aucune compétence dans cet onglet",
				description: "Essayez un autre onglet ou créez une compétence."
			},
			noSearchResults: {
				title: "Aucun résultat",
				description: "Aucune compétence ne correspond à votre recherche."
			}
		},
		error: {
			title: "Impossible de charger les compétences.",
			retry: "Réessayer"
		},
		new: {
			title: "Créer une compétence",
			back: "Compétences",
			intro: "Une compétence donne à l'assistant un savoir-faire précis, qu'il utilise quand la demande s'y prête."
		},
		detail: {
			back: "Toutes les compétences",
			updatedAt: "Mis à jour {{date}}",
			notFound: {
				title: "Compétence introuvable",
				description: "Cette compétence n'existe pas ou n'est pas accessible.",
				back: "Retour aux compétences"
			},
			error: {
				title: "Impossible de charger cette compétence.",
				retry: "Réessayer"
			},
			edit: {
				button: "Modifier",
				dropFile: "Déposer un fichier",
				delete: "Supprimer le fichier",
				editorPlaceholder: "Contenu du fichier…",
				binaryHint: "Fichier binaire : utilisez « Déposer un fichier » pour le remplacer.",
				discard: {
					title: "Abandonner les modifications ?",
					description: "Vous avez des modifications non enregistrées. Si vous quittez l'édition, elles seront perdues.",
					confirm: "Abandonner",
					cancel: "Continuer l'édition"
				}
			},
			files: {
				label: "Fichiers",
				raw: "Brut",
				loading: "Chargement…",
				loadError: "Impossible de charger ce fichier.",
				badge: {
					readme: "Lisez-moi",
					skill: "LLM"
				}
			},
			noReadme: "Cette compétence n'a pas de README.",
			dependencies: { title: "Dépendances" },
			danger: {
				title: "Zone de danger",
				deleteTitle: "Supprimer la compétence",
				description: "La suppression d'une compétence est définitive.",
				delete: "Supprimer"
			},
			deleteDialog: {
				title: "Supprimer « {{title}} » ?",
				description: "Cette action est irréversible. La compétence et ses fichiers seront définitivement supprimés.",
				confirm: "Supprimer",
				cancel: "Annuler",
				deleting: "Suppression…",
				failed: "La suppression a échoué."
			},
			rename: {
				title: "Renommer cette compétence ?",
				description: "Le nom de la compétence a changé. Ce nom est son identifiant unique : confirmez qu'il s'agit bien d'un choix volontaire avant d'enregistrer.",
				confirm: "Renommer et enregistrer",
				cancel: "Annuler",
				renaming: "Renommage…",
				failed: "Le renommage a échoué."
			},
			publish: {
				button: "Publier",
				publishing: "Publication…",
				failed: "La publication a échoué.",
				badge: "Modifications non publiées"
			}
		},
		form: {
			modeLabel: "Mode d'édition",
			modeForm: "Assisté",
			modeRaw: "Avancé",
			nonScalar: "Ce champ contient une valeur que le formulaire ne sait pas afficher. Modifiez-le en mode {{mode}}.",
			identifierLine: "Identifiant",
			identifierPending: "déduit du titre",
			identifierEdit: "Modifier",
			localized: "Ce champ existe en plusieurs langues, que le formulaire ne sait pas afficher. Modifiez-le en mode {{mode}}.",
			required: "Ce champ est nécessaire pour que la compétence fonctionne.",
			unavailable: {
				invalidYaml: "Le formulaire ne peut pas s'afficher : le texte comporte une erreur à la ligne {{line}}.",
				invalidYamlNoLine: "Le formulaire ne peut pas s'afficher : le texte comporte une erreur de syntaxe.",
				notAMapping: "Le formulaire ne peut pas s'afficher : l'en-tête du fichier n'est pas une liste de champs."
			},
			fields: {
				title: { label: "Titre" },
				name: {
					label: "Identifiant",
					description: "En minuscules, chiffres et tirets. Le changer renomme la compétence."
				},
				summary: {
					label: "Description",
					description: "Sans elle, la fiche affiche le texte « Quand utiliser cette compétence »."
				},
				description: {
					label: "Quand utiliser cette compétence",
					description: "C'est le seul texte que l'assistant lit pour décider. Décrivez les demandes avec les mots que vos utilisateurs emploient, et listez-les en entier : si vous écrivez « etc. », l'assistant invente la suite."
				},
				body: {
					label: "Instructions",
					description: "Le mode d'emploi que l'assistant suit quand il utilise la compétence. Allez droit au but : un exemple concret vaut mieux qu'un paragraphe d'explication."
				}
			},
			warnings: {
				noIdentifier: "Renseignez un identifiant, ou un titre qui en produise un : ce titre ne contient ni lettre ni chiffre.",
				invalidIdentifier: "Un identifiant s'écrit en minuscules, chiffres et tirets (exemple : nom-du-skill)."
			},
			sections: {
				catalog: {
					title: "La fiche de la compétence",
					description: "Ce que les gens lisent dans le catalogue pour la choisir."
				},
				agent: {
					title: "Ce qui pilote l'assistant",
					description: "L'assistant lit ces deux textes : le premier pour décider d'utiliser la compétence, le second pour s'en servir."
				}
			},
			optional: "facultatif"
		}
	},
	markdownEditor: {
		tabs: {
			edit: "Édition",
			preview: "Aperçu",
			label: "Vue de l'éditeur"
		},
		emptyPreview: "Rien à prévisualiser pour l'instant.",
		toolbar: {
			label: "Mise en forme",
			heading: "Titre",
			headingLevel: "Titre {{level}}",
			paragraph: "Texte normal",
			bold: "Gras",
			italic: "Italique",
			strikethrough: "Barré",
			bulletList: "Liste à puces",
			orderedList: "Liste numérotée",
			taskList: "Liste de tâches",
			quote: "Citation",
			inlineCode: "Code",
			codeBlock: "Bloc de code",
			link: "Lien",
			image: "Image",
			table: "Tableau",
			horizontalRule: "Ligne de séparation",
			column: "Colonne"
		}
	},
	invitations: {
		title: "Invitations",
		fromInviter: "De {{inviter}}, valable jusqu'au {{date}}.",
		validUntil: "Valable jusqu'au {{date}}.",
		accept: "Rejoindre",
		decline: "Refuser",
		joined: "Vous avez rejoint {{organization}}.",
		declined: "L'invitation à rejoindre {{organization}} est refusée.",
		acceptFailed: "Impossible de rejoindre l'organisation.",
		declineFailed: "Impossible de refuser l'invitation."
	},
	organizationSettings: {
		title: "Paramètres de l'organisation",
		sections: {
			general: "Général",
			members: "Membres"
		},
		loadFailed: "Impossible de charger l'organisation.",
		retry: "Réessayer",
		notFound: {
			title: "Organisation introuvable",
			description: "Elle n'existe pas, ou vous n'en êtes plus membre.",
			back: "Mes organisations"
		},
		members: {
			description: "Qui fait partie de l'organisation, et avec quel rôle.",
			listTitle: "Membres ({{count}})",
			adminCount_one: "{{count}} administrateur",
			adminCount_other: "{{count}} administrateurs",
			you: "{{name}} (vous)",
			sinceWithEmail: "{{email}} · depuis le {{date}}",
			since: "Depuis le {{date}}",
			inviteTitle: "Inviter un membre",
			emailLabel: "Adresse e-mail",
			emailPlaceholder: "adresse@exemple.fr",
			invite: "Inviter",
			inviteHint: "La personne reçoit un e-mail et retrouve l'invitation en se connectant avec cette adresse. Elle entre comme membre. L'invitation reste valable 14 jours.",
			invited: "Invitation envoyée à {{email}}.",
			inviteFailed: "L'invitation n'a pas pu être envoyée.",
			pending: "Envoyée le {{sent}} · expire le {{expires}}",
			noPending: "Aucune invitation en attente.",
			revoke: "Retirer",
			revoked: "Invitation retirée.",
			revokeFailed: "L'invitation n'a pas pu être retirée.",
			unnamed: "Membre sans nom",
			revokeLabel: "Retirer l'invitation de {{email}}",
			roleLabel: "Rôle de {{name}}",
			roleFailed: "Le rôle n'a pas pu être changé.",
			nowAdmin: "{{name}} est maintenant administrateur.",
			nowMember: "{{name}} est maintenant membre.",
			lastAdmin: "Seul administrateur : son rôle ne peut pas changer tant qu'un autre membre n'est pas promu.",
			remove: "Retirer de l'organisation",
			removeFailed: "Le membre n'a pas pu être retiré.",
			removed: "{{name}} ne fait plus partie de l'organisation.",
			removeDialog: {
				title: "Retirer {{name}} ?",
				description: "{{name}} perd l'accès à l'organisation. Pour revenir, cette personne devra y être invitée de nouveau."
			},
			actions: "Actions pour {{name}}"
		},
		general: {
			description: "L'identité de l'organisation.",
			name: "Nom",
			rename: "Renommer",
			save: "Enregistrer",
			cancel: "Annuler",
			renamed: "Organisation renommée.",
			renameFailed: "L'organisation n'a pas pu être renommée.",
			createdAt: "Créée le",
			yourRole: "Votre rôle",
			dangerZone: "Zone de danger",
			leaveTitle: "Quitter l'organisation",
			leaveDescription: "Vous n'en serez plus membre. Pour y revenir, un administrateur devra vous y inviter de nouveau.",
			left: "Vous avez quitté {{name}}.",
			deleteTitle: "Supprimer l'organisation",
			deleteDescription: "Tous ses membres en perdent l'accès. Cette suppression est définitive.",
			delete: "Supprimer",
			deleted: "{{name}} est supprimée.",
			deleteFailed: "L'organisation n'a pas pu être supprimée.",
			deleteDialog: {
				title: "Supprimer {{name}} ?",
				description_one: "Son unique membre en perd l'accès. Cette suppression est définitive.",
				description_other: "Ses {{count}} membres en perdent l'accès. Cette suppression est définitive."
			}
		}
	}
}, a = ["en", "fr"];
t.use(n).use(e).init({
	resources: {
		en: { translation: r },
		fr: { translation: i }
	},
	fallbackLng: "en",
	supportedLngs: a,
	debug: !1,
	interpolation: { escapeValue: !1 },
	detection: {
		order: ["localStorage", "navigator"],
		caches: ["localStorage"],
		lookupLocalStorage: "i18nextLng"
	}
});
//#endregion
export { a as SUPPORTED_LANGUAGES };

//# sourceMappingURL=config.js.map